import { CheckoutState } from '../../state';
import { getIsOnlyCheckoutFlow } from './getIsOnlyCheckoutFlow';
import { getIsTicketSelectionCompactSizeFlow } from './getIsTicketSelectionCompactSizeFlow';

export const shouldNavigateToTicketSelectionWhenClosingModal = (
    state: CheckoutState,
) => getIsOnlyCheckoutFlow(state) || getIsTicketSelectionCompactSizeFlow(state);
